import { OBJECTIVE_DEFINITIONS } from '@brick-rogue/game-content';
import type { GameplayAnalyticsEvent, ObjectiveMetric } from '@brick-rogue/game-core';
import {
  recordObjectiveProgress,
  type GameSave,
  type ObjectiveProgressIncrement,
  type ObjectiveProgressResult,
} from '@brick-rogue/persistence';

const BOSS_WAVES = new Set([10, 20, 30]);

export function createObjectiveProgressIncrements(
  event: GameplayAnalyticsEvent,
): readonly ObjectiveProgressIncrement[] {
  return Object.values(OBJECTIVE_DEFINITIONS).flatMap((definition) => {
    const amount = getMetricIncrement(definition.metric, event);
    return amount > 0 ? [{ objectiveId: definition.id, amount, target: definition.target }] : [];
  });
}

export function applyGameplayObjectiveEvent(
  save: GameSave,
  event: GameplayAnalyticsEvent,
  completedAt = new Date().toISOString(),
): ObjectiveProgressResult {
  return recordObjectiveProgress(save, createObjectiveProgressIncrements(event), completedAt);
}

function getMetricIncrement(metric: ObjectiveMetric, event: GameplayAnalyticsEvent): number {
  switch (metric) {
    case 'ability-uses':
      return Number(event.type === 'ability-used');
    case 'bosses-defeated':
      return Number(event.type === 'wave-completed' && BOSS_WAVES.has(event.wave));
    case 'events-resolved':
      return Number(event.type === 'run-event-action');
    case 'fusion-activated':
      return Number(event.type === 'run-ended' && event.ballFusionIds.length > 0);
    case 'curses-cleansed':
      return Number(event.type === 'run-cleanse-action' && event.action === 'cleansed');
    case 'full-runs-won':
      return Number(
        event.type === 'run-ended' &&
          event.reason === 'won' &&
          event.startingWave === 1 &&
          event.maxWaves === 30 &&
          event.wave === 30 &&
          event.stats.wavesCleared === 30,
      );
  }
}
